exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".viewstrap.vp-button.primary.skinny-button{min-width:100%}", ""]);

// exports
